import React from "react";
import styled from "styled-components";

import { parseAwsJson } from "@examspark/common";
import { RichContentDisplay, Tooltip } from "@examspark/common-ui";
import { ObjectiveBadge as InnerObjectiveBadge } from "@examspark/customer/tcmpc";

const StyledTooltip = styled.div`
  max-width: 20rem;
  font-size: 1.3rem;
  text-align: left;
  line-height: 1.9rem;
  padding: 0.5rem;
`;

const StyledRichContentDisplay = styled(RichContentDisplay)`
  p:first-child {
    margin-top: 0;
  }
  p:last-child {
    margin-bottom: 0;
  }
`;

type Props = React.ComponentProps<typeof InnerObjectiveBadge> & {
  showTooltip?: boolean;
};

const ObjectiveBadge = ({ showTooltip, ...props }: Props) => {
  const customizations = parseAwsJson<{ content: string | undefined }>(
    props.objectivesItem?.data,
  );

  return (
    <Tooltip
      disabled={!showTooltip}
      tip={
        <StyledTooltip>
          <StyledRichContentDisplay
            content={customizations?.content ?? props.objective?.content}
          />
        </StyledTooltip>
      }
      placement="top"
    >
      <InnerObjectiveBadge {...props} />
    </Tooltip>
  );
};

export default ObjectiveBadge;
